// extracted by mini-css-extract-plugin
module.exports = {"btns":"saledDrawer_btns__3Rvz1"};